import styled, { css } from 'styled-components';
import { textblocks, layouts, forms, buttons, icons } from 'seal-ui-components';
import { getBaseTheme } from '@Themes';

export const SystemItemLabel = styled(textblocks.Heading4)`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
`;

export const SystemItemActionMenu = styled.div`
    position: relative;
    > * {
        margin-right: ${getBaseTheme().spaces.default.xxs};
    }
    > *:last-child {
        margin-right: 0;
    }
    ${buttons.Button} {
        text-transform: none;
    }
`;

export const StatusDot = styled.div`
    min-width: ${getBaseTheme().sizes.xs};
    min-height: ${getBaseTheme().sizes.xs};
    border-radius: 50%;
    background: ${getBaseTheme().colors.notification.success.backgroundColor};
    visibility: ${({ authenticated, checked }) =>
        checked && authenticated ? 'visible' : 'hidden'};
`;

export const SystemItemLabelWrapper = styled(layouts.HorizontalBox)`
    height: 40px;
    padding: 0 ${getBaseTheme().spaces.default.xs};
    margin-top: ${getBaseTheme().spaces.default.xxs};
    background-color: ${({ authenticated, checked }) =>
        authenticated
            ? checked
                ? `${getBaseTheme().colors.control.active.backgroundColor};`
                : `${getBaseTheme().colors.control.default.backgroundColor};`
            : `${getBaseTheme().colors.control.default.backgroundColor}`};
    ${({ visible, checked }) =>
        visible &&
        checked &&
        css`
            background-color: ${getBaseTheme().colors.control.active.backgroundColor};
        `};

    &:hover {
        cursor: pointer;
        background-color: ${getBaseTheme().colors.control.hover.backgroundColor};

        .action-menu {
            white-space: nowrap;
            button {
                display: inline-block;
            }
        }
    }

    .action-menu {
        button {
            display: none;
        }
    }
`;

export const LoadingOverLay = styled.div`
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;
    position: absolute;
    background: rgba(0, 0, 0, 0.13);
    display: ${props => (props.loading ? 'flex' : 'none')};
`;

export const OverLaySpinner = styled(icons.LoadingLargeIcon)`
    flex: 1;
    align-self: center;
`;

export const SystemActionPanel = styled(layouts.VerticalBox)`
    padding: ${getBaseTheme().spaces.default.xs};
    height: auto;
    background: white;
    border: 1px solid ${getBaseTheme().colors.area.default.strokeColor};

    ${forms.StackedFieldLabel}, ${buttons.Button} {
        text-transform: none;
    }

    ${textblocks.Section} {
        > h3 {
            color: ${getBaseTheme().colors.control.error.complementaryForegroundColor};
        }
        > p {
            color: ${getBaseTheme().colors.control.error.complementaryForegroundColor};
            font-size: ${getBaseTheme().texts.sizes.s.fontSize};
            white-space: pre-wrap;
        }
    }

    span.delete_question {
        font-size: ${getBaseTheme().texts.sizes.s.fontSize};
    }

    > .BoxChild {
        margin-bottom: ${getBaseTheme().spaces.default.s} !important;
    }

    ${forms.FormGrid} {
        ${buttons.Button} {
            font-size: ${getBaseTheme().texts.sizes.s.fontSize};
        }
    }

    ${forms.FormGridFooter} {
        margin-bottom: 0;
        ${forms.FormButton} {
            text-transform: none;
        }
    }
`;
